var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linkWrap"},[_c(_vm.hasLink ? 'a' : 'div',{tag:"component",staticClass:"link",attrs:{"href":_vm.hasLink ? '/account/user/' + _vm.line.user_id : null,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" "+_vm._s(_vm.line.employee)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }